
import { createClient } from '@supabase/supabase-js';

// 안전한 환경변수 읽기 (import.meta 오류 방지)
const getEnvVar = (key: string): string => {
  // Vite 환경
  if (typeof window !== 'undefined' && (window as any).__ENV__) {
    const envKey = key.replace('VITE_PUBLIC_', '').replace('NEXT_PUBLIC_', '');
    return (window as any).__ENV__[envKey];
  }
  
  // import.meta 환경 (Vite)
  try {
    if (import.meta && import.meta.env) {
      return import.meta.env[key];
    }
  } catch (e) {
    // import.meta를 사용할 수 없는 환경
  }
  
  // Next.js 환경
  if (typeof process !== 'undefined' && process?.env) {
    return process.env[key];
  }
  
  return '';
};

const supabaseUrl = getEnvVar('VITE_PUBLIC_SUPABASE_URL') || 'https://your-project.supabase.co';
const supabaseAnonKey = getEnvVar('VITE_PUBLIC_SUPABASE_ANON_KEY') || 'your-anon-key';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase 환경변수가 설정되지 않았습니다.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
